import { Button, Checkbox, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTriumphPayControl extends Layout {
    buttonAuthorize: Button;
    buttonGenerateToken: Button;
    checkboxBillReceivedDate: Checkbox;
    checkboxBolReceived: Checkbox;
    checkboxBolRecvDate: Checkbox;
    checkboxExcludeNontriumphPayees: Checkbox;
    checkboxIsDefault: Checkbox;
    checkboxManualPymt: Checkbox;
    checkboxPreventUnpostedWire: Checkbox;
    checkboxReadyToBill: Checkbox;
    checkboxSendAllContactInfo: Checkbox;
    checkboxUpdExistingCarriers: Checkbox;
    dataHeaderTriumphPayControl: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    labelAuthorizedStatus: Label;
    labelRequiredFields: Label;
    sourceTriumphpayControl: DataSource;
    sourceTriumphpayFieldInfo: DataSource;
    sourceTriumphpayFieldList: DataSource;
    switchIsActive: Switch;
    tabDataOutput: Tab;
    tabGeneral: Tab;
    tableTriumphPayFieldList: Table;
    tabset1: Tabset;
    textboxClientId: Textbox;
    textboxClientSecret: Textbox;
    textboxLastRun: Textbox;
    textboxLastUpdate: Textbox;
    textboxProcessDate: Textbox;
    textboxProcessDaysBack: Textbox;
    textboxRefreshToken: Textbox;
    textboxRunInterval: Textbox;
    textboxUpdateInterval: Textbox;
    textboxVendorUrl: Textbox;
}
